<template>
    <div class="error-back">
        <Button @click="goHome" size="large" style="width: 200px;" type="text">返回首页</Button>
        <Button @click="backPage" size="large" style="width: 200px;margin-left: 40px;" type="primary">返回上一页</Button>
    </div>
</template>

<script>
    export default {
        name: "errorBack",
        props: {
            backNum: {
                type: Number,
                default: -1
            }
        },
        data () {
            return {};
        },
        methods: {
            goHome () {
                this.$router.push({
                    name: "home"
                });
            },
            backPage () {
                this.$router.go(this.backNum);
            }
        }
    };
</script>

<style lang="less" scoped>
    .error-back{
        text-align: center;
        padding-top: 40px;
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/pages/Error/errorBack.vue